import Cookies from "js-cookie";

const TokenKey = "user_token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function Language() {
  return Cookies.get('locale');
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function getUserInfo() {
  if (Cookies.get("user_info")) {
    return JSON.parse(Cookies.get("user_info"));
  } else {
    return null;
  }
}

export function setUserInfo(info) {
  return Cookies.set("user_info", info);
}

// 清除本地缓存的用户信息，避免失效登录态在刷新后被重新初始化
export function removeUserInfo() {
  return Cookies.remove("user_info");
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js